import { useStores } from "../../store";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useObserver } from "mobx-react";
import { useRef, useState } from "react";
import { apiPostPut } from "../../api/api_methods";
import Loader from "../reusble_components/loader";
import { useNavigate } from "react-router-dom";

export default function TermsAndConditionsPopup(props) {
  const { UserStore } = useStores();
  const [show, setShow] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const Accepted = useRef(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [userId, setUserId] = useState(null);
  let userIdFromLocal = JSON.parse(localStorage.getItem("user")); 


  const [body, setBody] = useState(
    {
      userId: userIdFromLocal?._id || UserStore?.user?._id,
      eventId: "6706480f3e21f1ccae0bcc1f"
  })

  const Whatsapp_groupLink = process.env.WHATSAPP_GROUP_LINK ?? "https://chat.whatsapp.com/D9kpTDsatylICAyuOgKltA";
 
  const postData = async () => {
    setLoader(true);
    const response = await apiPostPut(body, "/enrollment/enroll-event", "POST");
    if(response.status === 200) {
      UserStore.setTermsAndConditionsPopup(false);
      alert("Enrolled Successfully");
      setLoader(false);
      alert("We are Navigating to you for a whatsapp Group for better Communication");
      window.location.href = Whatsapp_groupLink;
      UserStore?.setTermsAndConditionsPopup(false);
      setIsAccepted(false);
    }
    else {
      console.log(response);
      alert(response?.body?.message);
      let confirm = window.confirm("Do you want to join the Whatsapp group for this job fair?");
      if(confirm) {
        window.location.href = Whatsapp_groupLink;
      }
      setLoader(false);
      UserStore?.setTermsAndConditionsPopup(false);
      setIsAccepted(false);
    }
  }

  return useObserver(() => (
    <>
      {UserStore?.termsAndConditionsPopup ? (
        <div onClick={() => UserStore.setTermsAndConditionsPopup(false)} className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-md bg-opacity-10">
          <div onClick={(e) => e.stopPropagation()} className="absolute overflow-y-clip inset-0 bg-bg3 z-50 flex flex-col px-10 rounded-3xl border  items-center md:w-[60%] lg:w-[70%] w-[95%] h-[70vh] pb-5 m-auto shadow-lg no-scrollbar">
            <AiOutlineCloseCircle
              className="absolute text-xl cursor-pointer top-2 right-2"
              onClick={() => {
                UserStore.setTermsAndConditionsPopup(false);
              }}
            />
              <Loader loader={loader} />
              <h1 className="mt-10 text-lg font-semibold">
                Reaidy.io AI Job Fair - Terms and Conditions
              </h1>

            <div className="w-full h-full overflow-hidden overflow-y-scroll pb-5">
             <div>
             <p className={` mt-2  md:mt-5 lg:mt-10  text-sm md:text-base   text-gray-500 `}>
                1. <b className="ml-1"> Online-Only Event </b> The AI Job Fair will take place
                <b className="ml-1">exclusively online</b> through the Reaidy.io platform. <br /> 2. 
                <b className="ml-1">AI-Assisted Skill Assessment</b> Initial interviews will be
                conducted by an AI to assess candidates' skills based on the job
                role applied for. <br /> 3. <b className="ml-1">Recording During the Interview</b> During
                the interview process, both <b className="ml-1">video</b> and <b className="ml-1">screen recordings</b>
                of the candidates will be captured. These recordings will be
                made available to the hiring HR teams and managers for
                evaluation purposes. <br /> 4. <b className="ml-1">Data Privacy</b> Reaidy.io guarantees
                that candidates' details, recordings, and other personal
                information will be <b className="ml-1">strictly shared only with the HR teams</b>
                and HR managers of the participating companies. No data will be
                disclosed to any third party without consent. <br /> 5. <b className="ml-1">Job
                Applications</b> Candidates are allowed to apply for <b className="ml-1">up to 3 job
                positions</b> at no cost. If a candidate wishes to apply for
                additional positions, a fee of <b className="ml-1">₹99 per job</b> will be charged. <br />
                6. <b className="ml-1">Platform Role</b> Reaidy.io serves solely as a platform to
                <b className="ml-1">connect job seekers with potential employers</b>. We facilitate
                interviews but are not responsible for the final hiring
                decisions. <br /> 7. <b className="ml-1">No Job Guarantee</b> Participation in the AI Job
                Fair does not guarantee <b className="ml-1">100% job placement</b>. Job offers are
                at the discretion of the hiring companies based on their
                criteria. <br /> 8. <b className="ml-1">Merit-Based Placement</b> Job placements will be
                determined by the candidate's <b className="ml-1">skills</b>, <b className="ml-1">experience</b>, and
                <b className="ml-1">interview performance</b>, as evaluated by the respective hiring
                companies.
              </p>
              {/* {!show ? ( <p className="text-sm cursor-pointer w-fit text-primary lg:hidden" onClick={() => setShow(!show)}>View More</p>) : <p className="text-sm cursor-pointer w-fit lg:hidden text-primary" onClick={() => setShow(!show)}>View Less</p>} */}
                <div className="flex md:flex-row lg:flex-row flex-col w-full gap-5 justify-between items-center mt-5">
                <div className=" flex items-center gap-x-3">
                <input type="checkbox" ref={Accepted} onClick={() => {
                  if(Accepted.current.checked) {
                    setIsAccepted(true);
                    setBody({...body, isAccepted: true});
                  }
                  else {
                    setIsAccepted(false);
                    setBody({...body, isAccepted: false});
                  }
                }} className="h-4 w-4" name="" id="" />
                <p className="h-5 text-sm"> Accept the Conditions</p>
                </div>
                {isAccepted ? <button className="md:text-lg lg:text-lg text-xs bg-primary text-white font-semibold md:px-10 lg:px-10 px-5 mr-5 cursor-pointer rounded-full md:py-3 lg:py-3 py-2" onClick={() => postData()} >Enroll Now</button> : <button className="md:text-lg lg:text-lg mr-5 text-xs bg-gray-400 text-white font-semibold md:px-10 lg:px-10 px-5 cursor-not-allowed rounded-full md:py-3 lg:py-3 py-2">Enroll Now</button>}
                </div>
             </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  ));
}
